<template>
    <span v-show="unreadCount" class="badge badge-primary">{{ unreadCount }}</span>
  </template>
  
  <script>
  import { EventBus } from './../eventBus';
  export default {
    props: ["count", "name","chanel"],
    data() {
      return {
        unreadCount: this.count,
        undeadCountEBName: 'user-'+this.name+'-unread-count-changed'
      };
    },
    mounted() {
      window.Echo.private('chat-unread-messages')
        .listen('SendUnreadMessageCount', e => {
          if(e.chanelId == this.chanel) {
            this.unreadCount = e.unreadMessagesCount;
          }
        });
    },
    created() {
      EventBus.$on(this.undeadCountEBName,  (count) => { 
        this.unreadCount = Math.max(0, this.unreadCount - count);
      });

    
    },
    methods: {
      updateCount(count) {
        this.unreadCount = count;
      }
    },
    beforeDestroy() {
      EventBus.$off('user-'+this.name + '-unread-count-changed', this.updateCount);
    }
  };
  </script>
  